module.exports = __webpack_public_path__ + "media/images/pc/page_common/suns_header_bg-e7108940151f07bb6e6b64efdc76c8ba.png";